const externalLinkAriaLabels = () => {
	let allATags = document.querySelectorAll('a');

	if (allATags) {
		allATags.forEach(aTag => {
			const target = aTag.getAttribute('target');

			if (target === '_blank') {
				if (!aTag.hasAttribute('aria-label')) {
					aTag.setAttribute('aria-label', 'Link to external website that opens in a new tab');
				} else {
					let ariaLabel = aTag.getAttribute('aria-label');
					if (ariaLabel.indexOf('new tab') === -1) {
						aTag.setAttribute('aria-label', ariaLabel + ' (Opens in a new tab)');
					}
				}
			} else {
				if (!aTag.hasAttribute('aria-label')) {
					aTag.setAttribute('aria-label', 'Link to page that opens in the same tab');
				}
			}
		});
	}
};

const contactForm7Ada = () => {
	// Contact Form 7
	document.addEventListener('wpcf7invalid', function (event) {
		console.log('wpcf7invalid');
		const form = event.target;

		form.querySelectorAll('.wpcf7-not-valid').forEach(function (field) {
			field.setAttribute('aria-invalid', 'true');

			const error = field.parentNode.querySelector('.wpcf7-not-valid-tip');
			if (error) {
				const id = field.name + '-error';
				error.id = id;
				field.setAttribute('aria-describedby', id);
			}
		});

		const firstElementContainer = form.querySelector('.wpcf7-form-control-wrap');

		if (firstElementContainer) {
			const input = firstElementContainer.querySelector('input, select, textarea');
			if (input) {
				input.focus();
			}
		}
	});

	document.addEventListener('wpcf7submit', function (event) {
		const statusBox = document.querySelector('.wpcf7-accessible-status');
		if (statusBox) {
			statusBox.textContent = event.detail.apiResponse.message;
		}
	});
};

const skipLinkFunctions = () => {
	// Skip to main content
	const skipLink = document.querySelector('.skip-link-to-main');
	if (skipLink) {
		// Handle keyboard navigation (Enter and Space keys)
		skipLink.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				const mainElement = document.querySelector('#main');
				if (mainElement) {
					mainElement.focus();
					mainElement.scrollIntoView({ behavior: 'smooth' });
				}
			}
		});

		// Handle mouse clicks
		skipLink.addEventListener('click', function (e) {
			e.preventDefault();
			const mainElement = document.querySelector('#main');
			if (mainElement) {
				mainElement.focus();
				mainElement.scrollIntoView({ behavior: 'smooth' });
			}
		});
	}

	// Skip to main content
	const skipLinkTop = document.querySelector('.skip-link-to-top');
	if (skipLinkTop) {
		var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
		let mainNavElement = '';
		if (viewportWidth >= 992) {
			mainNavElement = document.querySelector('#main-navigation');
		} else {
			mainNavElement = document.querySelector('#main-navigation-trigger');
		}

		// Handle keyboard navigation (Enter and Space keys)
		skipLinkTop.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				if (mainNavElement) {
					mainNavElement.focus();
					mainNavElement.scrollIntoView({ behavior: 'smooth' });
				}
			}
		});

		// Handle mouse clicks
		skipLinkTop.addEventListener('click', function (e) {
			e.preventDefault();
			if (mainNavElement) {
				mainNavElement.focus();
				mainNavElement.scrollIntoView({ behavior: 'smooth' });
			}
		});
	}
};

const dmDesignMyNightAda = () => {
	// Design My Night
	dmnBookingWidget = document.querySelector('#dmn-partner-widget');

	if (dmnBookingWidget) {
		const svgs = dmnBookingWidget.querySelectorAll('svg');

		if (!svgs.length) {
			return;
		}

		svgs.forEach(svg => {
			svg.removeAttribute('id');
			svg.querySelectorAll('[id]').forEach(el => {
				el.removeAttribute('id');
			});
		});
	}
};

externalLinkAriaLabels();
contactForm7Ada();
skipLinkFunctions();
dmDesignMyNightAda();